<div class="env-vars-container">


  <!-- Control buttons -->
  <div class="controls-section">
    <button class="btn btn-primary" (click)="refreshEnvVariables()" [disabled]="loading">
      <i class="zmdi zmdi-refresh" [class.spinning]="loading"></i>
      {{ loading ? 'Refreshing...' : 'Force Refresh Environment Variables' }}
    </button>
  </div>

  <!-- Error message -->
  @if (error) {
    <div class="error-message">
      <i class="zmdi zmdi-alert-triangle"></i>
      {{ error }}
    </div>
  }

  <!-- Loading indicator -->
  @if (loading && !error) {
    <div class="loading-message">
      <i class="zmdi zmdi-spinner zmdi-hc-spin"></i>
      Loading environment variables...
    </div>
  }

  <!-- Environment Variables Tables -->
  @if (!loading) {
    <div class="env-vars-tables">
      <!-- Scheduler Environment Variables -->
      @if (schedulerEnvVars.length > 0) {
        <div class="table-container">
          <div class="table-label-container">
            <mat-label class="table-label">Scheduler Environment Variables</mat-label>
          </div>
          <div class="table-wrapper">
            <table class="env-vars-table styled-table">
              <thead class="table-headers">
                <tr>
                  <th class="header-column variable-name">Variable Name</th>
                  <th class="header-column variable-value">Value</th>
                </tr>
              </thead>
              <tbody>
                @for (envVar of schedulerEnvVars; track envVar) {
                  <tr class="table-row">
                    <td class="variable-name">{{ envVar.key }}</td>
                    <td class="variable-value">{{ envVar.value }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <!-- Slave Environment Variables -->
      @if (slaveEnvVars.length > 0) {
        <div class="table-container">
          <div class="table-label-container">
            <mat-label class="table-label">Slave Environment Variables</mat-label>
          </div>
          <div class="table-wrapper">
            <table class="env-vars-table styled-table">
              <thead class="table-headers">
                <tr>
                  <th class="header-column variable-name">Variable Name</th>
                  <th class="header-column variable-value">Value</th>
                </tr>
              </thead>
              <tbody>
                @for (envVar of slaveEnvVars; track envVar) {
                  <tr class="table-row">
                    <td class="variable-name">{{ envVar.key }}</td>
                    <td class="variable-value">{{ envVar.value }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <!-- Other Environment Variables -->
      @if (otherEnvVars.length > 0) {
        <div class="table-container">
          <div class="table-label-container">
            <mat-label class="table-label">Other Environment Variables</mat-label>
          </div>
          <div class="table-wrapper">
            <table class="env-vars-table styled-table">
              <thead class="table-headers">
                <tr>
                  <th class="header-column variable-name">Variable Name</th>
                  <th class="header-column variable-value">Value</th>
                </tr>
              </thead>
              <tbody>
                @for (envVar of otherEnvVars; track envVar) {
                  <tr class="table-row">
                    <td class="variable-name">{{ envVar.key }}</td>
                    <td class="variable-value">{{ envVar.value }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <!-- No environment variables message -->
      @if (schedulerEnvVars.length === 0 && slaveEnvVars.length === 0 && otherEnvVars.length === 0 && standardEnvVars.length === 0) {
        <div class="no-data-message">
          <i class="zmdi zmdi-info"></i>
          No environment variables found for this job.
        </div>
      }
    </div>
  }
</div>